export type ChatDisplayMessage = {
  id: string | number;
  role: "user" | "assistant";
  content: string;
  createdAt?: string;
  status?: string;
};

export function chatMessageFromFileLibrary(message: {
  id: number;
  role: string;
  content: string;
  created_at: string;
  status: string;
}): ChatDisplayMessage {
  return {
    id: message.id,
    role: message.role === "assistant" ? "assistant" : "user",
    content: message.content,
    createdAt: message.created_at,
    status: message.status,
  };
}

/** Hide in-flight assistant placeholders; the loading indicator covers that state. */
export function isVisibleInFileLibraryThread(message: ChatDisplayMessage): boolean {
  if (message.role === "user") return true;

  const status = message.status ?? "completed";
  if (status === "pending" || status === "processing") return false;

  return message.content.trim().length > 0;
}
